<template>
  <div class="qb-result-wrapper">
    <QBVideoList
      v-if="shortVideo.length"
      ref="qbVideoListRef"
      :get-doc-info="getDocInfo"
      :get-short-video-play-info="getShortVideoPlayInfo"
    />
    <NoResult v-else />
  </div>
</template>

<script>
import { throttle  } from '@asset/js/util';
import * as types from '@types';
import { mapActions, mapMutations, mapState } from 'vuex';

import NoResult from './NoResult.vue';
import QBVideoList from './QBVideoList.vue';

export default {
  components: {
    QBVideoList,
    NoResult,
  },
  props: {
    getDocInfo: {
      type: Function,
      default: () => null,
    },
    getShortVideoPlayInfo: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('common', ['$config', 'loadingFinished']),
    ...mapState('search', ['shortVideo', 'query', 'maxEnd']),
  },
  mounted() {
    this.initScrollLoad();
    this.handleSearchRecords();
  },
  beforeDestroy() {
    if (typeof this.handleScrollLoad === 'function') {
      window.removeEventListener('scroll', this.handleScrollLoad);
    }
  },
  methods: {
    ...mapMutations('common', [types.UPDATE_LOADING_FINISHED]),
    ...mapActions('search', ['getNextPageData']),
    handleSearchRecords() {
      try {
        const { query } = this;
        if (query.length < 38) {
          let searchRecords = localStorage.getItem('v_search_record');
          if (searchRecords && searchRecords.length > 0) {
            searchRecords = JSON.parse(searchRecords);
            if (Array.isArray(searchRecords)) {
              const curIndex = searchRecords.indexOf(query);
              if (curIndex > -1) {
                searchRecords.splice(curIndex, 1);
              }
              if (searchRecords.length === 10) {
                searchRecords.pop();
              }
              searchRecords.unshift(query);
            }
          } else {
            searchRecords = [];
            searchRecords.unshift(query);
          }
          localStorage.setItem('v_search_record', JSON.stringify(searchRecords));
        }
      } catch (err) {
        console.log(err);
      }
    },
    initScrollLoad() {
      // 滚动加载
      this.handleScrollLoad = throttle(async () => {
        const html = document.documentElement;
        const { body } = document;
        const winH = window.innerHeight;
        const scrollH = Math.max(html.scrollHeight, body.scrollHeight);
        const scrollTop = html.scrollTop || body.scrollTop;
        const shortLength = this.shortVideo ? this.shortVideo.length : 0;
        if (shortLength >= this.maxEnd) {
          this[types.UPDATE_LOADING_FINISHED](true);
        }
        if (
          !this.loading
          && !this.loadingFinished
          && scrollH - winH > scrollTop - 50
          && scrollH - winH < scrollTop + 50
        ) {
          this.loading = true;
          await this.getNextPageData({
            params: this.$route.query,
            callback: () => {
              this.loading = false;
            },
            failed: (err) => {
              this.loading = false;
              console.log(err);
            },
          });
        }
      }, 500);
      window.addEventListener('scroll', this.handleScrollLoad);
    },
  },
};
</script>
